// Copyright 2025. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';

export const InfoBlock = styled.div`
    padding: 20px 16px;
`;
